/**
 * Environment configuration
 * Centralizes all environment-specific settings
 */

export const config = {
  /**
   * Auth service base URL
   * Used for authentication, registration, and user management
   */
  authServiceUrl: import.meta.env.VITE_AUTH_SERVICE_URL || 'http://localhost:8080',

  /**
   * Farmers service base URL
   * Used for FPO configuration and dynamic ERP URL resolution
   */
  farmersServiceUrl: import.meta.env.VITE_FARMERS_SERVICE_URL || 'http://localhost:8000',

  /**
   * ERP service base URL (optional fallback)
   * The dynamic URL from FPO config is the primary source
   * Only set this in .env if you need a fallback for development
   */
  erpServiceUrl: import.meta.env.VITE_ERP_SERVICE_URL || '',

  /**
   * API request timeout in milliseconds
   */
  apiTimeout: 30000,

  /**
   * Enable Redux DevTools
   */
  enableDevTools: import.meta.env.DEV,
} as const;

export type Config = typeof config;
